"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidebarSection = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var SidebarSection = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.el, Element = _b === void 0 ? 'div' : _b, _c = _a.padding, padding = _c === void 0 ? true : _c, props = __rest(_a, ["children", "className", "el", "padding"]);
    var SidebarClasses = classnames_1.default('SidebarSection', className, {
        'SidebarSection--p-x': padding === 'x',
        'SidebarSection--p-y': padding === 'y',
        'SidebarSection--p-none': !padding,
    });
    return (react_1.default.createElement(Element, __assign({ className: SidebarClasses }, props), children));
};
exports.SidebarSection = SidebarSection;
//# sourceMappingURL=SidebarSection.js.map